module.exports = __webpack_public_path__ + "static/cellphoneHome-a0b6de91f69af579289f6ce00a691189.png";